import TransactionsDetailedHeader from '../TransactionsDetailedHeader/index'
import Btn from '../Btn/index'
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'SettledTransaction',
  components: { TransactionsDetailedHeader, Btn },
  props: [],
  data () {
    return {
      settled_txn_params: {
        skip:0,
        count:5
      },
      pages_loaded:1,
      settledTxnsLoaded:false
    }
  },
  computed: {
    ...mapGetters([
      "settledTransactions",
      "settledTxnError"
    ])
  },
  mounted () {
    this.loadTransactions(false)
  },
  methods: {
    loadMore() {
      this.settled_txn_params.skip = this.settled_txn_params.count * this.pages_loaded
      this.pages_loaded++
      this.loadTransactions(true)
    },
    loadTransactions (append) {
      var query = this.settled_txn_params;
      if(append){
        var query = {
          params:this.settled_txn_params,
          append
        }
      }

      /* this.$store.dispatch("settledTransactions", query).finally(()=>{
        this.settledTxnsLoaded = true
      }) */
      this.$store.dispatch('settledTransactions', query).then(resp => {
        this.settledTxnsLoaded = true
      })
    },
    setActiveTransaction (txn) {
      localStorage.setItem("from", "SettledTransaction")
      this.$store.dispatch('activeTransaction', txn)
      this.$router.push({path: 'settled/transaction/'+txn.id})
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/SettledTransactions/component.js